import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Modal, Row, Table } from 'react-bootstrap';
import { FaEye, FaFileAlt, FaLink, FaUserNinja } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { default as swal } from 'sweetalert2';
import Pagination from '../../Pagination';
import './CandidateDashboard.css';
import DashboardLayout from './DashboardLayout';
import GlobalCandidateSettings from './GlobalCandidateSettings';

const Resume = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const userName = location.state?.userName;
  const userId = location.state?.userId;

  const [showMessage, setShowMessage] = useState(false);
  const [resumes, setResumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resumeDetails, setResumeDetails] = useState(null);
  const [viewResume, setViewResume] = useState(false);
  const [viewCount, setViewCount] = useState(false);
  const [eachViewCount, setEachViewCount] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null); // Track the currently sorted column
  const [sortOrder, setSortOrder] = useState(' '); // Track the sort order (asc or desc)
  const [resumeMessage, setresumeMessage] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6); // Default page size
  const [totalPages, setTotalPages] = useState(0);
  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;

  const handlePageClick = (data) => {
    setPage(data.selected);
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  useEffect(() => {
    // Fetch resumes data from the backend
    axios.get(`${BASE_API_URL}/getResume?userId=${userId}`)
      .then(response => {
        setResumes(response.data);
        setLoading(false); // Stop loading when resumes are fetched
      })
      .catch(error => {
        console.error('Error fetching resumes:', error);
        setLoading(false); // Stop loading even if there's an error
      });
  }, [userId]);

  const detailsRef = useRef(null); // Ref for the details section
  const resumeRef = useRef([]); // Ref for the resumes cards section (array of refs)
  const [activeResumeRef, setActiveResumeRef] = useState(null); // Store active resume card reference

  const [resumeId, setResumeId] = useState(null);

  const handleViewResumeDetailsWithPagination = async (resume, resumeIndex) => {
    setViewResume(true);
    const resumeId = resume.id;
    setViewCount(resume.viewCount);
    setresumeMessage(resume.message);
    setResumeId(resumeId); // Store the resumeId in a state variable
    setPage(0); // Reset to the first page

    // Ensure the ref is correctly updated
    if (resumeRef.current[resumeIndex]) {
      setActiveResumeRef(resumeRef.current[resumeIndex]);
    }


    // Scroll to resume details section
    if (detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    const fetchResumeDetails = async () => {
      if (resumeId && !isNaN(resumeId)) {
        try {
          const response = await axios.get(`${BASE_API_URL}/getResumeDetailsWithPagination`, {
            params: {
              resumeId: resumeId,
              page: page,
              pageSize: pageSize,
              sortedColumn: sortedColumn,
              sortOrder: sortOrder,
            },
          });

          console.log(response.data);
          const { content, totalPages } = response.data;
          setResumeDetails(content);
          setTotalPages(totalPages);
        } catch (error) {
          console.error(`Error fetching details for resume ${resumeId}:`, error);
        }
      }
    };

    fetchResumeDetails();
  }, [page, pageSize, resumeId, sortedColumn, sortOrder]); // Dependencies updated



  useEffect(() => {
    if (resumeDetails && resumeDetails.length > 0) {
      resumeDetails.forEach(async (application) => {
        const { companyName, resumeId, jobId } = application;

        console.log("companyName --", companyName, " -----resumeId", resumeId, "---------jobId", jobId);

        try {
          // Call the backend API to get the view count
          const response = await axios.get(`${BASE_API_URL}/eachResumeViewCount`, {
            params: {
              resumeId: resumeId,
              companyName: companyName,
              jobId: jobId
            },
          });
          const viewCount = response.data;

          application.viewCount = viewCount; // Store viewCount in the application object
          setEachViewCount(viewCount);  // Update the state for each view count
          console.log("companyName --", companyName, " -----resumeId", resumeId, "---------jobId", jobId, 'View Count for Resume:', viewCount);

        } catch (error) {
          console.error('Error fetching view count:', error);
        }
      });
    }
  }, [resumeDetails]);

  const handleDownload = async (resumeId, fileName) => {
    try {
      const response = await axios.get(`${BASE_API_URL}/downloadResume?resumeId=${resumeId}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  };

  const [showBriefSettings, setShowBriefSettings] = useState(false);
  const handleBrief = async (resumeId, fileType) => {
    const response = await axios.get(`${BASE_API_URL}/getBriefResume?resumeId=${resumeId}`);
    if (response) {
      setShowMessage(response.data);
      setShowBriefSettings(!showBriefSettings);
    }
  };

  const navigate = useNavigate();
  const toggleSettings = () => {
    navigate('/');
  };

  const handleDelete = async (resumeId, message) => {
    const result = await swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    });

    if (result.isConfirmed) {
      try {
        await axios.put(
          `${BASE_API_URL}/deleteResume`,
          null, 
          {
            params: {
              resumeId:resumeId,
              userId:userId, 
            },
          }
        );
        setResumes(prevResumes => prevResumes.filter(resume => resume.id !== resumeId));
        swal.fire('Deleted!', `${message} has been deleted.`, 'success');

      } catch {
        swal.fire('Failed', 'Error deleting resume', 'error');
      }
    } else {
      swal.fire('Cancelled', 'Your resume is safe', 'error');
    }
  };

  const handleClose = () => {
    setViewResume(false); // Hide the resume details
    // setResumeDetails([]); // Clear the resume details

    // Scroll back to the resume card that was clicked for preview
    if (activeResumeRef) {
      activeResumeRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const handleSort = (column) => {
    if (sortedColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(column);
      setSortOrder("asc");
    }
  };

  return (
    <DashboardLayout >
      <div ref={activeResumeRef} className="main-content">
        <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
          <Col xs="auto">
            <h2 className='text-start' style={{ paddingLeft: '12px', marginBottom: '5px' }}>My Resumes</h2>
            <p className='text-start'>(If you want to view your resume details please click on <strong style={{ color: 'red' }}>Analytics </strong>)</p>

          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings userId={userId} />

          </Col>
        </Row>
        <Row className="mb-3 px-3 d-flex justify-content-end">
          <Col xs="auto">
            <Link to="/candidate-dashboard/resume/resumeAdd" state={{ userName: userName, userId: userId }}>
              <Button variant="primary">+ ADD NEW RESUME</Button>
            </Link>
          </Col>
        </Row>


        {showBriefSettings && (
          <Modal show={showBriefSettings} onHide={() => setShowBriefSettings(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Brief Resume</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: 'auto' }}>
              {showMessage}
            </Modal.Body>
          </Modal>
        )}

        {/* <h2 className='text-start'>MY RESUMES</h2>
        <p className='text-start'>(If you want to view your resume details please click on <strong style={{ color: 'red' }}>Preview </strong>)</p> */}

        {loading ? (
          <div className="text-center">
            <div className="d-flex justify-content-center">
              <div className="spinner-bubble spinner-bubble-primary m-5" />
            </div>
            <h4>Please wait... Fetching your resumes...</h4>
          </div>
        ) : (
          <>
            {resumes.length === 0 ? (
              <div className="text-center">No resumes found</div>
            ) : (
              <div className="cards d-flex flex-wrap justify-content-start" style={{ minHeight: 'fit-content' }}>
                {resumes.map((resume, index) => (
                  <Card className='resume-card' style={{ width: '200px', margin: '12px' }} key={resume.id} ref={el => resumeRef.current[index] = el}>
                    <Card.Body>
                      <Card.Title>
                        Resume : {index + 1} {' '}
                        {resume.fileType === 'file' && <FaFileAlt className="text-success" style={{ marginLeft: '40px' }} />}
                        {resume.fileType === 'brief' && <FaUserNinja className="text-primary" style={{ marginLeft: '40px' }} />}
                        {resume.fileType === 'link' && <FaLink className="text-info" style={{ marginLeft: '40px' }} />}
                      </Card.Title>
                      <Card.Text>{resume.message}</Card.Text>

                      {resume.fileType === 'file' && (
                        <Button size="sm" className="download" variant="primary" onClick={() => handleDownload(resume.id, resume.fileName)}>
                          Download
                        </Button>
                      )}
                      {resume.fileType === 'link' && (
                        <Card.Link href={resume.fileName} target="_blank">Open Link</Card.Link>
                      )}
                      {resume.fileType === 'brief' && (
                        <Button variant="secondary" size="sm" className="open-brief-modal" onClick={() => handleBrief(resume.id, resume.fileType)}>
                          {/* Open Brief */} View
                        </Button>
                      )}
                      <Button variant="danger" size="sm" className="delete" style={{ marginLeft: '10px' }} onClick={() => handleDelete(resume.id, resume.message)}>
                        Delete
                      </Button>
                      <h5
                        className="text-center"
                        style={{
                          marginTop: '10px',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          color: '#0d6efd' // Bootstrap primary blue
                        }}
                        onClick={() => handleViewResumeDetailsWithPagination(resume, index)}
                      >
                        <FaEye /> Analytics
                      </h5>

                    </Card.Body>
                  </Card>
                ))}
              </div>
            )}
          </>
        )}

        <div ref={detailsRef} className="container mt-5">
          {viewResume && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-primary">{resumeMessage}</h4>
                <h5 className="text-muted">Resume Analytics - {viewCount}</h5>
                <Button onClick={handleClose}>Close</Button>
              </div>
              <hr style={{ borderTop: "1px solid purple", marginTop: "15px", marginBottom: "15px" }} />

              {resumeDetails && resumeDetails.length > 0 ? (
                <>
                  <Table hover className="text-center">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          onClick={() => handleSort("companyName")}
                          style={{ cursor: "pointer" }}
                        >
                          Company{" "}
                          <span>
                            <span style={{ color: sortedColumn === "companyName" && sortOrder === "asc" ? "black" : "gray" }}>
                              ↑
                            </span>{" "}
                            <span style={{ color: sortedColumn === "companyName" && sortOrder === "desc" ? "black" : "gray" }}>
                              ↓
                            </span>
                          </span>
                        </th>

                        <th
                          scope="col"
                          onClick={() => handleSort("jobRole")}
                          style={{ cursor: "pointer" }}
                        >
                          Job Title{" "}
                          <span>
                            <span style={{ color: sortedColumn === "jobRole" && sortOrder === "asc" ? "black" : "gray" }}>
                              ↑
                            </span>{" "}
                            <span style={{ color: sortedColumn === "jobRole" && sortOrder === "desc" ? "black" : "gray" }}>
                              ↓
                            </span>
                          </span>
                        </th>

                        <th
                          scope="col"
                          onClick={() => handleSort("appliedOn")}
                          style={{ cursor: "pointer" }}
                        >
                          Applied On{" "}
                          <span>
                            <span style={{ color: sortedColumn === "appliedOn" && sortOrder === "asc" ? "black" : "gray" }}>
                              ↑
                            </span>{" "}
                            <span style={{ color: sortedColumn === "appliedOn" && sortOrder === "desc" ? "black" : "gray" }}>
                              ↓
                            </span>
                          </span>
                        </th>

                        <th>Views</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resumeDetails.map((application, index) => (
                        <tr key={index}>
                          <td>{application.companyName}</td>
                          <td>{application.jobRole ? application.jobRole : "Dream application"}</td>
                          <td>{application.appliedOn ? application.appliedOn : "N/A"}</td>
                          <td>{application.viewCount || "0"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  {/* Pagination Component */}
                  <Pagination
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    handlePageSizeChange={handlePageSizeChange}
                    isPageSizeDisabled={isPageSizeDisabled}
                    handlePageClick={handlePageClick}
                  />
                </>
              ) : (
                <p>Resume is not used in any application.</p>
              )}
            </>
          )}
        </div>

      </div>

    </DashboardLayout>
  );
};

export default Resume;
